import { z } from "zod";

import { NIKE_URL } from "@/data/constants/url";
import { createHttpErrorMessage } from "@/utils/create-http-error-message";

const tradingViewConfigSchema = z.object({
  data: z.object({
    supported_resolutions: z.array(z.string()),
    supports_group_request: z.boolean(),
    supports_marks: z.boolean(),
    supports_search: z.boolean(),
    supports_time: z.boolean(),
  }),
  message: z.string(),
});

export type TradingViewConfig = z.infer<typeof tradingViewConfigSchema>;

export const getTradingViewConfig = async (): Promise<
  TradingViewConfig["data"]
> => {
  const endpoint = `/tradingview-chart/config`;
  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "GET",
    cache: "no-cache",
  });
  if (!res.ok) {
    const errorMessage = await createHttpErrorMessage(endpoint, res);
    throw new Error(errorMessage);
  }
  return tradingViewConfigSchema.parse(await res.json()).data;
};
